module.exports = __webpack_public_path__ + "assets/images/vcr_operahouse-04.5b285fb584628315a6b62d8e4f1ffe4a.svg";